import { ApiContext } from './Api.context.ts';
import type { TApiProviderProps } from './Api.types.ts';

export const ApiProvider = ({ api, children }: TApiProviderProps) => (
  <ApiContext.Provider value={api}>{children}</ApiContext.Provider>
);
